import { useCan } from "components";
import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useManufacturerDashboardListeners } from "modules/ManufacturerDashboard/listeners";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useManufacturerNotificationCountQuery = () => {
  const listeners = useManufacturerDashboardListeners();
  const { selectedLocation } = useSelectedLocation();
  const canUpdateManufacturerRequests = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.ManufacturerRequest);

  const { data: manufacturerNotificationCount, isLoading: isLoadingNotificationCount } = useRealTimeTypedQuery({
    queryKey: ManufacturerQueryKeys.manufacturerRequestCount,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.count,
    enabled: Boolean(selectedLocation?.id && canUpdateManufacturerRequests),
    listeners
  });

  return { manufacturerNotificationCount, isLoadingNotificationCount };
};
